import type { EntityData } from '@ContractBuilder/types';
import type { ResourceBlock } from '@root/@types/base';
import { getAllBlocks } from '@root/helpers/blocks';
import { isEndorsementViewPath } from '@utils/app-paths';
import { pick } from 'lodash-es';

export type StateFromBlock = Pick<
  ResourceBlock,
  | 'blockLibraryId'
  | 'canDelete'
  | 'canDeleteOnTemplate'
  | 'canEdit'
  | 'canEditOnTemplate'
  | 'class_of_business'
  | 'classification'
  | 'clause_reference'
  | 'clause_type'
  | 'content'
  | 'created_at'
  | 'updated_at'
  | 'created_by'
  | 'last_updated_by'
  | 'deleted_at'
  | 'helperText'
  | 'id'
  | 'isVisible'
  | 'last_imported_at'
  | 'linkedDatapoints'
  | 'name'
  | 'repeaterIds'
  | 'section_id'
  | 'selectedVariationId'
  | 'shouldInsertPageBreak'
  | 'teams'
  | 'title'
  | 'type'
  | 'usedInTemplates'
  | 'variations'
  | 'visibility'
  | 'visibilityComputed'
>;

export const getFormStateFromBlock = (submission?: EntityData, blockId?: string): StateFromBlock | undefined => {
  const isEndorsementView = isEndorsementViewPath();
  const allBlocks = getAllBlocks(submission, isEndorsementView);
  const block = allBlocks.find((item) => item.id === blockId);

  if (!block) {
    return undefined;
  }

  const keysToPick: Array<keyof ResourceBlock> = [
    'blockLibraryId',
    'canDelete',
    'canDeleteOnTemplate',
    'canEdit',
    'canEditOnTemplate',
    'class_of_business',
    'classification',
    'clause_reference',
    'clause_type',
    'content',
    'created_at',
    'deleted_at',
    'updated_at',
    'created_by',
    'last_updated_by',
    'expiry_date',
    'helperText',
    'id',
    'inception_date',
    'isVisible',
    'last_imported_at',
    'linkedDatapoints',
    'name',
    'parentBlockId',
    'repeaterIds',
    'section_id',
    'selectedVariationId',
    'shouldInsertPageBreak',
    'teams',
    'title',
    'type',
    'usedInTemplates',
    'variations',
    'visibility',
    'visibilityComputed',
  ];

  return pick(block, keysToPick) as StateFromBlock;
};
